import { gql } from '@apollo/client';

export default gql`
  query searchVessel(
    $query: String!
    $pageSize: Int!
    $lastPageToken: VesselPageTokenInput
  ) {
    searchVessel(
      query: $query
      pageSize: $pageSize
      lastPageToken: $lastPageToken
    ) {
      vessels {
        id
        name
        imo
        eni
        mmsi
        callSign
        uscg
      }
      lastPageToken {
        vesselId
        weight
        orderingIndexKey
      }
    }
  }
`;
